<template>
    <div class="loading" :class="{small, light, middle}"/>
</template>

<script>
export default {
  name: "app-loader",
  props: {
    small: {
      type: Boolean,
      default: false
    },
    middle: {
      type: Boolean,
      default: false
    },
    light: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .loading{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    position: relative;

    &.middle {
      width: 35px;
      height: 35px;
    }

    &.small {
      width: 20px;
      height: 20px;
      &:before,&:after {
        border-width: 2px !important;
      }
    }
    &.light{
      &:before{
        border: 3px solid white;
        border-top: 3px solid transparent;
        border-left: 3px solid transparent;
        border-right: 3px solid transparent;
      }
      &:after {
        border: 3px dashed white;
        border-top: 3px solid transparent;
        border-left: 3px solid transparent;
        border-right: 3px solid transparent;
      }
    }

    &:before{
      width: 100%;
      border-radius: inherit;
      content: '';
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      border: 3px solid #2CB181;
      border-top: 3px solid transparent;
      border-left: 3px solid transparent;
      border-right: 3px solid transparent;
      animation: rotate .7s ease infinite;
    }

    &:after{
      width: 100%;
      border-radius: inherit;
      content: '';
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      border: 3px dashed #2CB181;
      border-top: 3px solid transparent;
      border-left: 3px solid transparent;
      border-right: 3px solid transparent;
      animation: rotate .7s linear infinite;
    }
  }
  @keyframes rotate {
    0%{
      transform: rotate(0deg);
    }
    100%{
      transform: rotate(360deg);
    }
  }
</style>
